{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -81.40700089685271,
              30.700537086701274
            ],
            [
              -84.62837811801556,
              30.78143989025179
            ],
            [
              -87.46582096482277,
              30.651823254145967
            ],
            [
              -87.56219405787051,
              30.204049030530157
            ],
            [
              -83.97475845335121,
              29.275247249470468
            ],
            [
              -83.35284699959432,
              28.245701677268002
            ],
            [
              -81.87306737151782,
              24.793238979587045
            ],
            [
              -79.86735022303866,
              24.99008353274361
            ],
            [
              -79.7954503737093,
              27.27182009477191
            ],
            [
              -81.40700089685271,
              30.700537086701274
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}